import { useEffect, useState } from "react";
import { SmarticoButtonDataModel } from "./types";

const MAX_RETRIES = 5;
let CURRENT_RETRY = 1;

const FunCentre = ({
  smarticoData,
  classNames,
  funCentreTextClassNames,
  funCentreLogoClassNames,
}: {
  smarticoData: SmarticoButtonDataModel;
  classNames?: string;
  funCentreTextClassNames?: string;
  funCentreLogoClassNames?: string;
}) => {
  const [avatarUrl, setAvatarUrl] = useState("/assets/images/smartico/icon-hourglass.svg");

  useEffect(() => {
    const onEffectLoad = () => {
      if (CURRENT_RETRY >= MAX_RETRIES) {
        return;
      }
      CURRENT_RETRY++;
      if (!window._smartico || !window?._smartico?.api) {
        setTimeout(onEffectLoad, 1000);
        return;
      }
      updateValueFromSmartico();
      window._smartico.on("props_change", function (props: any) {
        updateValueFromSmartico(props);
      });
    };
    onEffectLoad();
    return () => {
      if (window._smartico) {
        window._smartico.off("props_change");
      }
    };
  }, []);

  const onContainerClick = () => {
    window._smartico.dp("dp:gf");
  };

  const updateValueFromSmartico = (userProfile?: any) => {
    if (!userProfile) {
      userProfile = window._smartico.api.getUserProfile();
    }
    try {
      if (userProfile) {
        if (
          (userProfile.avatar_url && userProfile.avatar_url.length > 0) ||
          (userProfile.avatar_id && userProfile.avatar_id.length > 0)
        ) {
          setAvatarUrl(userProfile.avatar_url || userProfile.avatar_id);
        }

        // Unread messages
        const unreadMessages = userProfile.core_inbox_unread_count;
        if (unreadMessages && unreadMessages > 0) {
          const circleElement = document.querySelector(".fun-centre-container .fun-centre-circle");
          if (circleElement) {
            circleElement.innerHTML = String(unreadMessages);
            circleElement.classList.add("active");
          }
        }
      }
    } catch (ex) {
      console.error(ex);
    }
  };

  return (
    <div
      onClick={onContainerClick}
      className={`fun-centre-container lg:w-32 p-[0.1rem] gap-2 flex rounded-full cursor-pointer items-center bg-[linear-gradient(270deg,#fcb045_0%,#fe2d2d_50%,#9430d8_100%)] ${classNames}`}>
      <img
        src={avatarUrl}
        alt="smartico-fun-centre"
        className={`fun-centre-logo  w-[36px] h-[36px] ${funCentreLogoClassNames !== undefined ? funCentreLogoClassNames : ""}`}
      />
      <span
        className={`fun-centre-text text-white lg:text-[14px] font-medium lg:whitespace-nowrap ${funCentreTextClassNames !== undefined ? funCentreTextClassNames : ""}`}>
        Fun Centre
      </span>
      <div className="fun-centre-circle"></div>
    </div>
  );
};

export default FunCentre;
